<div
	class="ngx-banner"
	[class.ngx-banner--neutral]="type === bannerType.Neutral"
	[class.ngx-banner--info]="type === bannerType.Info"
	[class.ngx-banner--success]="type === bannerType.Success"
	[class.ngx-banner--warning]="type === bannerType.Warning"
	[class.ngx-banner--danger]="type === bannerType.Danger">
	<div class="ngx-banner-content">
		<ng-content></ng-content>
		@if (dismissable) {
			<span class="dismiss-button">
				<button class="close-btn btn-none" type="button" aria-label="{{'common_close' | translate}}" (click)="onBannerDismissed.emit()">
					<i class="ficon-app-x"></i>
				</button>
			</span>
		}
	</div>
</div>
